import React, { useState } from 'react';
import axios from 'axios';
import { Calendar, Phone, User, FileText, Car } from 'lucide-react';

const CustomerRegister = () => {
  const [formData, setFormData] = useState({
    full_name: '',
    phone: '',
    plate_number: '',
    license_number: '',
    policy_end_date: ''
  });
  
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: '', type: '' });

    try {
      const response = await axios.post('https://centalyayanimda.com/add_customer.php', formData, {
        withCredentials: true
      });

      if (response.data.success) {
        setMessage({ text: 'Müşteri başarıyla kaydedildi!', type: 'success' });
        // Form verilerini sıfırla
        setFormData({
          full_name: '',
          phone: '',
          plate_number: '',
          license_number: '',
          policy_end_date: ''
        });
      } else {
        setMessage({ text: response.data.message || 'Bir hata oluştu.', type: 'error' });
      }
    } catch (error) {
      console.error('Müşteri kaydı sırasında hata:', error);
      setMessage({ text: 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white/80 backdrop-blur-lg rounded-2xl p-6 shadow-lg border border-gray-100">
      <h2 className="text-2xl font-bold mb-6 bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent">
        Müşteri Kayıt
      </h2>

      {message.text && (
        <div className={`p-3 mb-4 rounded-lg ${
          message.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
        }`}>
          {message.text}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <label htmlFor="full_name" className="block text-sm font-medium text-gray-700 flex items-center">
            <User className="mr-2 h-4 w-4 text-blue-500" />
            Müşteri Adı Soyadı
          </label>
          <input
            type="text"
            id="full_name"
            name="full_name"
            required
            value={formData.full_name}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
            placeholder="Ahmet Yılmaz"
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700 flex items-center">
            <Phone className="mr-2 h-4 w-4 text-blue-500" />
            Telefon Numarası
          </label>
          <input
            type="text"
            id="phone"
            name="phone"
            required
            value={formData.phone}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
            placeholder="05XX XXX XX XX"
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="plate_number" className="block text-sm font-medium text-gray-700 flex items-center">
            <Car className="mr-2 h-4 w-4 text-blue-500" />
            Plaka
          </label>
          <input
            type="text"
            id="plate_number"
            name="plate_number"
            required
            value={formData.plate_number}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
            placeholder="34ABC123"
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="license_number" className="block text-sm font-medium text-gray-700 flex items-center">
            <FileText className="mr-2 h-4 w-4 text-blue-500" />
            Ruhsat Numarası
          </label>
          <input
            type="text"
            id="license_number"
            name="license_number"
            required
            value={formData.license_number}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
            placeholder="Ruhsat Numarası"
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="policy_end_date" className="block text-sm font-medium text-gray-700 flex items-center">
            <Calendar className="mr-2 h-4 w-4 text-blue-500" />
            Poliçe Bitiş Tarihi
          </label>
          <input
            type="date"
            id="policy_end_date"
            name="policy_end_date"
            required
            value={formData.policy_end_date}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className={`w-full py-2 px-4 mt-6 rounded-lg text-white font-medium 
            ${loading ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'} 
            transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`}
        >
          {loading ? 'Kaydediliyor...' : 'Müşteri Kaydet'}
        </button>
      </form>
    </div>
  );
};

export default CustomerRegister;